export enum MercerSupportDetailsComponentTab {
  Survey = 'mercer-support.dialog.survey',
  JobProfile = 'mercer-support.dialog.job-profile',
  Placement = 'mercer-support.dialog.placement',
  ActivityStreams = 'mercer-support.dialog.activitiy-streams',
  Comments = 'mercer-support.dialog.comments'
}
